import React from "react";
import { Calendar, Percent, Eye, Check } from "lucide-react";

export type CloseFYStep = 1 | 2 | 3;

const STEPS: { step: CloseFYStep; label: string; icon: React.ReactNode }[] = [
  { step: 1, label: "Year end dates", icon: <Calendar className="w-3.5 h-3.5" /> },
  { step: 2, label: "Discount & remark", icon: <Percent className="w-3.5 h-3.5" /> },
  { step: 3, label: "Preview", icon: <Eye className="w-3.5 h-3.5" /> },
];

interface CloseFYStepperProps {
  currentStep: CloseFYStep;
}

const CloseFYStepper: React.FC<CloseFYStepperProps> = ({ currentStep }) => {
  return (
    <nav className="flex items-center w-full mb-6 gap-0" aria-label="Close FY steps">
      {STEPS.map(({ step, label, icon }, index) => {
        const isActive = currentStep === step;
        const isCompleted = currentStep > step;
        const isLast = index === STEPS.length - 1;

        return (
          <React.Fragment key={step}>
            <div className="flex flex-col items-center flex-1 min-w-0">
              <div
                className={`
                  flex items-center justify-center w-8 h-8 rounded-full border-2 shrink-0 transition-colors
                  ${isCompleted ? "bg-brand border-brand text-white" : ""}
                  ${isActive ? "border-brand bg-brand/10 text-brand" : ""}
                  ${!isActive && !isCompleted ? "border-gray-200 bg-gray-50 text-gray-400" : ""}
                `}
                aria-current={isActive ? "step" : undefined}
              >
                {isCompleted ? <Check className="w-4 h-4" /> : icon}
              </div>
              <span
                className={`
                  mt-1.5 text-xs font-medium text-center truncate w-full px-0.5
                  ${isActive ? "text-brand" : ""}
                  ${isCompleted ? "text-gray-600" : ""}
                  ${!isActive && !isCompleted ? "text-gray-400" : ""}
                `}
              >
                {label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`
                  flex-shrink-0 w-8 h-0.5 -mt-5
                  ${currentStep > step ? "bg-brand" : "bg-gray-200"}
                `}
                aria-hidden
              />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default CloseFYStepper;
